import AdVm from '../../vms/ads/AdVm'
import BaseView from '../BaseView'
import { classList } from '../../../utils/dom'
import { queryString } from '../../../utils/window'
import { CLASS_NAMES } from '../../config/adsConfig'
import setPageTargeting from '../../vms/ads/adTargeting'
import { adStore, adActions } from '../../stores/adStore'

const { adsDebugSizes } = queryString
const { EMPTY } = CLASS_NAMES

const CLASS_CONSTANTS = {
  AD_WIDTH: 'ad-width',
  AD_HEIGHT: 'ad-height',
}
const { AD_WIDTH, AD_HEIGHT } = CLASS_CONSTANTS

export default class BaseAdView extends BaseView {
  constructor(element, adConfig, store) {
    super(...arguments)
    const adId = element.dataset.slotId
    const { type } = adConfig
    const adVm = AdVm.create({
      adId,
      type,
      adConfig: adConfig.doubleClick,
      store: store || adStore,
      actions: adActions,
    })
    this.merge({
      initialized: false,
      adVm,
      adId,
    })
    adVm.gTagService.globalInitGtag(setPageTargeting.part(adVm.gTagService.gTag))
  }

  isEmptySlot() {
    const { emptySlot, adSize } = this.adVm
    const { width, height } = adSize
    return emptySlot.isEmpty || !width || !height
  }

  get adSizesClassNames() {
    if (this.isEmptySlot()) {
      return [EMPTY]
    }
    const { width, height } = this.adVm.adSize
    return [`${AD_WIDTH}--${width}`, `${AD_HEIGHT}--${height}`]
  }

  get adClassList() {
    const currentSlot = this.options
    const currentSlotClassList = classList(currentSlot)
    const classNamesToFilter = [AD_WIDTH, AD_HEIGHT, EMPTY]
    return Array.from(currentSlotClassList)
      .filter(className =>
        classNamesToFilter.every(classToFilter => !className.startsWith(classToFilter))
      )
      .concat(this.adSizesClassNames)
  }

  get renderParams() {
    const { adVm } = this
    const params = {
      attributes: {
        id: adVm.adData.slotDivId,
      },
    }
    const currentSlot = this.options
    adsDebugSizes && this.info(currentSlot.dataset.slotId, this.adId, this.adClassList)
    currentSlot.className = this.adClassList.join(' ')
    if (!this.initialized) {
      params.callback = adVm.initAndDisplay.bind(adVm)
    }
    this.initialized = true
    return params
  }

  display() {
    this.adVm.display()
    return this
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/ads/BaseAdView.js